module.exports = __webpack_public_path__ + "img/app_img2.a0263e72.png";